<template>
  <div class="rpg-pd-5">
    <div class="rpg-pd-5-10 rpg-bd-b rpg-pr-title">
      <span class="rpg-label">{{ project.客户公司 }}-{{ project.项目名称 }}</span>
      <span class="rpg-gray">（当前项目）</span>
      <span class="rde-text" @click="openTrainingVideo"
        ><i class="el-icon-video-camera-solid" style="font-size:20px"></i>如何背景调查</span
      >
    </div>
    <div class="rpg-pd-5-10 rpg-label">
      背景调查
      <el-button type="text"><i class="el-icon-notebook-1 rpg-btn-text" @click="gotoPeixun">培训</i></el-button>
      <el-button class="video-btn" style="margin-left:10px;" type="text" @click="openTrainingVideo"
        ><i class="el-icon-video-camera-solid" style="font-size:20px"></i>如何背景调查</el-button
      >
    </div>
    <div class="rpg-pd-5">
      <el-button type="primary" size="mini" @click="downloadFile">下载模板【模板】背景调查报告</el-button>
      <el-button size="mini" @click="showFile">查看范本</el-button>
    </div>
    <div class="rpg-pd-5">
      <div class="rpg-bd rpg-pd-10 rpg-mgb-5">
        如何做背调？<br /><br />
        1. 方法：和做 mapping 一样：打他同事去了解，谁好，谁不好，好在哪里，不暴露我们是在做一个人的背景调查<br /><br />
        2. 话术：听说你们资管做得很不错，还获了很多奖，团队很厉害呀?是股东资源吗？
        这几年各家风险事件很多，你们的都处理完了嘛?资管几个核心领导谁比较厉害?什么风格呀<br />
      </div>
      <div class="rpg-bd rpg-pd-10 rpg-mgb-5">
        背景调查坚持原则<br /><br />

        1. 坚信任何人都不会百分百好评，我们本着对客户负责任和对人选负责任的态度 ，
        会客观公正，帮客户把好关，也会帮人选理清，能澄清的澄清，真的有问题的 ， 我们会坚决 cancel 掉。<br /><br />

        真的问题有：<br /><br />

        （1） 确实是需要人选背责任的风险事件<br /><br />

        （2） 口碑很差，人品不太好<br /><br />

        （3） 简历里面业绩有水分，实际业绩很一般<br /><br />

        （4） 简历造假<br /><br />

        2. 能够赢得客户信任而且一直信任的是帮助客户把好关的顾问<br /><br />

        3. 把问题提前暴露，但是有自己观点，往往让客户更信任，以及愿意接受顾问的 解决方案<br />
      </div>
    </div>
    <!-- <div class="rpg-dialog-item">
      <label>相关附件：</label>
      <span class="rpg-btn-text" @click="showUpload"> <i class="el-icon-circle-plus"></i> 上传相关附件 </span>
      <ul>
        <li v-for="(attach, k) in attachs" :key="k">{{ attach.originalname }}</li>
      </ul>
    </div> -->
    <!-- <UploadDialog
      ref="UploadDialog"
      type="背景调查"
      label="背景调查"
      title="上传背景调查相关资料附件"
      :on-success="uploadSuccess"
    /> -->
  </div>
</template>
<script>
// import { UploadDialog } from '../../../file'
// import project_notify from '../constant/project_notify'
import { download } from '../../../project/src/constant/utils'

export default {
  // components: { UploadDialog },
  props: {
    radish: {
      type: Object,
    },
    project: {
      type: Object,
    },
    onConfirm: {
      type: Function,
      default: function() {},
    },
  },
  data() {
    return {
      rid: '',
      pid: '',
      attachs: [],
      file: {
        _id: 'e0e2b0b6e2fabe4f4cafb778f2a539bd',
        createdAt: 1585104965127,
        encoding: '7bit',
        filename: 'B1pBuSuIL.模板背景调查报告2020-3-25.doc',
        md5: 'e0e2b0b6e2fabe4f4cafb778f2a539bd',
        mimeType: 'application/msword',
        originalname: '【模板】背景调查报告2020-3-25.doc',
        size: 157184,
        src: '/upload/附件/B1pBuSuIL.模板背景调查报告2020-3-25.doc',
        type: '附件',
        uploader: ['NateYu', 'mxluo'],
        previewurl: '/upload/preview.e0e2b0b6e2fabe4f4cafb778f2a539bd.【模板】背景调查报告2020-3-25.pdf',
      },
    }
  },
  async mounted() {
    this.rid = this.radish.rid || this.radish._id
    this.pid = this.project._id
    // 获取附件
    const aRes = await app.service('radish').listAttachment({ rid: this.rid })
    if (aRes.status == 'succcess') {
      this.attachs = aRes.data.filter(a => a.type == '背景调查')
    }
  },
  methods: {
    openTrainingVideo() {
      app.root.$refs.TrainingVideoDialog.open('背景调查')
    },
    gotoPeixun() {
      window.open(`${window.frontend}/#/catalogue/培训`, '_blank')
    },
    // showUpload() {
    //   this.$refs.UploadDialog && this.$refs.UploadDialog.visible(true)
    // },
    // async uploadSuccess(response, file, fileList) {
    //   const attachData = []
    //   response.forEach(res => {
    //     let dt = {
    //       fileId: res._id,
    //       uploader: res.uploader,
    //       originalname: res.originalname,
    //       src: res.src,
    //       md5: res.md5,
    //       rid: this.rid,
    //       type: '背景调查',
    //     }
    //     attachData.push(dt)
    //   })
    //   const aRes = await app.service('radish').addAttachment(attachData)
    //   if (aRes.status == 'success') {
    //     this.$message.success('上传成功')
    //     this.attachs = this.attachs.concat(attachData)
    //     this.$refs.UploadDialog.visible()
    //     project_notify.sendMessage(this.rid, this.pid, '-背景调查', '背景调查', { 内容: '已上传背景调查' })
    //   }
    // },
    async showFile() {
      const ref = window.app.root.$refs.cvPreview
      if (!ref) return
      await ref.getFile(this.file)
      ref.show()
    },
    downloadFile() {
      download(this.file)
    },
  },
}
</script>
<style>
@import '../../static/css/progress.css';
</style>
